<template lang="pug">
  b-modal(id="modal-policy-accept" hide-header-close no-close-on-esc no-close-on-backdrop title="利用規約が新しくなりました")
    .text-center
      a(href="https://sitelead.notion.site/SiteLead-2aaa1f34e38c809cbf8dff4356818095", target="_blank") 利用規約
    .text-center
      a(href="https://sitelead.notion.site/SiteLead-2aaa1f34e38c80ccb051d539e84f87c5", target="_blank") 特定商取引法に基づく表記
    .text-center
      a(href="https://sitelead.notion.site/SiteLead-2aaa1f34e38c80b29bbef53910f853ad", target="_blank") プライバシーポリシー
    .text-center
      a(href="https://sitelead.notion.site/SiteLead-2aaa1f34e38c801db096d39e7b6525ce", target="_blank") クッキーポリシー
    .text-center.mt-3
      b-form-checkbox(
        id="policy-accept"
        v-model="status"
        name="policy-accept"
        value="accepted"
        unchecked-value="not_accepted"
      ) 利用規約・プライバシーポリシーの内容を確認しました
    template(v-slot:modal-footer)
      template(v-if="status === 'accepted'")
        b-button(variant="primary", @click="submit($event)") 規約に同意して利用する
      template(v-else)
        b-button(variant="primary" disabled) 規約に同意して利用する
</template>

<script>
  import Vue from 'vue'

  export default {
    props: {
      current_policy_status: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
        status: 'not_accepted'
      }
    },
    methods: {
      async submit(e){
        e.preventDefault();
        const version = this.current_policy_status?.version
        await this.$store.dispatch("user/acceptPolicy", version)
        this.$bvModal.hide('modal-policy-accept')
      },

    },
    components: {
    },
    async mounted(){
      await Vue.nextTick()
      const accepted = this.current_policy_status?.accepted
      if (accepted === false) {
        this.$bvModal.show('modal-policy-accept')
      }
    },
  }
</script>